import { minutesToStringDate } from "../../../../utils";
import * as s from "./styles";

type Props = {
    limitHours: number;
    totalTime: number;
};

type TimeToWidth = {
    time: number;
    total: number;
};

export function DailyGoalTimeline({ limitHours, totalTime }: Props) {
    const getTotalTime = () => {
        return limitHours;
    };

    const timeToWidth = ({ time, total }: TimeToWidth) => (time / total) * 100;

    const returnPendingHours = (limitHours: number, totalTime: number) => {
        if (limitHours - totalTime < 0) {
            return minutesToStringDate(0);
        }
        return minutesToStringDate(limitHours - totalTime);
    };

    return (
        <s.Container>
            <div id="container-infos">
                <div id="info-left">
                    <s.Paragraph>{minutesToStringDate(totalTime)}</s.Paragraph>
                    <s.GrayParagraph>Horas trabalhadas</s.GrayParagraph>
                </div>
                <div id="info-right">
                    <s.Paragraph>
                        {returnPendingHours(limitHours, totalTime)}
                    </s.Paragraph>
                    <s.GrayParagraph>Horas restantes</s.GrayParagraph>
                </div>
            </div>
            <s.BarContainer
                percentage={timeToWidth({
                    time: totalTime,
                    total: getTotalTime(),
                })}
            >
                <s.Bar
                    percentage={timeToWidth({
                        time: limitHours,
                        total: getTotalTime(),
                    })}
                />
                <s.BarDelimiter id="delimiter" />
            </s.BarContainer>
        </s.Container>
    );
}
